import { render, staticRenderFns } from "./AssetHandler.vue?vue&type=template&id=1339122a&scoped=true"
import script from "./AssetHandler.vue?vue&type=script&lang=js"
export * from "./AssetHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1339122a",
  null
  
)

export default component.exports